import { jsx as _jsx } from "react/jsx-runtime";
import Iframe from "./Iframe";
const IframePreview = () => {
    return (_jsx("div", { children: _jsx(Iframe, { url: "https://fr.wikipedia.org" }) }));
};
export default IframePreview;
